import React, {useEffect, useState} from "react";
import { useLocation } from "react-router-dom";
import Grid from "@mui/material/Grid";
import CVTemplate from "./CVTemplate";
import {getJobById} from "../../utilities/cvAPI";
import PublicLayout from "../../templates/PublicLayout";

export default function ExternalCV() {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const jobID = searchParams.get('jobID');
    const [hashCode, setHashCode] = useState(null);

    useEffect(() => {
        if (jobID) {
            getJobById(jobID)
                .then(data => {
                    setHashCode(data.hashedCode);
                })
                .catch(err => {
                    console.error("Error fetching job:", err);
                });
        }
    }, [jobID]);

    return (
        <PublicLayout hashCode={hashCode}>
            {jobID ? (
                <CVTemplate jobId={jobID}/>
            ) : (
                <Grid item>
                    <h5 data-testid={"noJobProvided"} className={"gridPadding"}>No job provided</h5>
                </Grid>
            )}
        </PublicLayout>
    );
}
